<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {
    if (this._isMobile()) {
      // this.$message.success("手机端");
      // this.$store.state.client = 2;
      this.$store.state.client = 1;
    } else {
      // console.log(
      //   "%c代理商\n当前版本: V1.0\n更新时间: 2022-03-4 16:55",
      //   "color: #409eff;font-size: 14px"
      // );
      // this.$message.success("pc端");
      this.$store.state.client = 1;
    }
    // 监听浏览器刷新
    // window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    this.$router.push("/home/main");
    this.$store.state.checktabs = [];
  },
  // 监听浏览器刷新
  // destroyed() {
  //   window.removeEventListener("beforeunload", (e) =>
  //     this.beforeunloadHandler(e)
  //   );
  // },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    // 监听浏览器刷新
    beforeunloadHandler(e) {
      e = e || window.event;
      if (e) {
        e.returnValue = "关闭提示";
      }
      // window.sessionStorage.setItem("a", 1);

      return "关闭提示";
    },
  },
};
</script>
